import { render, staticRenderFns } from "./AppFooterFull.vue?vue&type=template&id=1f89079f&scoped=true&"
import script from "./AppFooterFull.vue?vue&type=script&lang=js&"
export * from "./AppFooterFull.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterFull.vue?vue&type=style&index=0&id=1f89079f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89079f",
  null
  
)

export default component.exports